import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import auth from "../auth";
import getInitials from "../utils/getInitials";

function deleteCookie(name) { setCookie(name, "", -10); }
function setCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

const PipeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h9a3 3 0 0 1 3 3 3 3 0 0 0 3 3h3"/>
    <circle cx="6" cy="16" r="2"/><path d="M8 16h6"/>
  </svg>
);
const LogoutIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
    <polyline points="16 17 21 12 16 7"/>
    <line x1="21" y1="12" x2="9" y2="12"/>
  </svg>
);

class Topbar extends Component {
  getCookie = (name) => {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length);
    }
    return null;
  };

  componentDidMount() { window.scrollTo(0, 0); }

  render() {
    const username = this.getCookie('asa_hd_lu') || '';
    const initials = getInitials(username) || username.substring(0, 2).toUpperCase() || 'U';

    return (
      <div className="ds-topbar">
        <div className="ds-brand">
          <div className="ds-brand-mark"><PipeIcon /></div>
          <div className="ds-brand-titles">
            <div className="ds-brand-t1">Oldelval <span className="light">· App Externos</span></div>
            <div className="ds-brand-t2">Portal de <b>Solicitudes de Interferencias</b></div>
          </div>
        </div>

        <div className="ds-topbar-spacer" />

        <div className="ds-topbar-right">
          <div className="ds-company-chip">
            <div className="ds-company-co">
              <span className="ds-company-name">{username || 'Mi cuenta'}</span>
              <span className="ds-company-role">Contratista externo</span>
            </div>
            <Link to="/account" className="ds-avatar" title="Mi cuenta">{initials}</Link>
          </div>

          <button
            className="ds-t-iconbtn"
            title="Cerrar sesión"
            onClick={() => {
              auth.logout(() => {
                deleteCookie("asa_hd_auth");
                this.props.history.push("/");
              });
            }}
          >
            <LogoutIcon />
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(Topbar);
